export const SET_YEAR = "SET_YEAR";
export const SET_MAKE = "SET_MAKE";
export const SET_MODEL = "SET_MODEL";
export const SET_CATEGORY = "SET_CATEGORY";
export const SET_VIN = "SET_VIN";